import { Helmet } from 'react-helmet-async';
import { WidgetEditorForm } from '@/pages/widgetEditor/components/WidgetEditorForm.tsx';
import { useTranslation } from 'react-i18next';
import { PageWithLayout } from '@/models/page';
import { FullScreenLayout } from '@/layouts/fullScreen/FullScreenLayout';
import type { FunctionComponent, PropsWithChildren } from 'react';

// ponytail: one hardcoded token for every operator until the endpoint
// (access token + liftOperatorId) exists; then load it here instead.
const INTEGRATION_TOKEN = '';

/**
 * `getLayout` is called outside of a component body, so the translated title is
 * resolved here instead of being passed in directly.
 */
const WidgetEditorLayout: FunctionComponent<PropsWithChildren<unknown>> = ({
    children,
}) => {
    const { t } = useTranslation();

    return (
        <FullScreenLayout
            title={t('widgetEditor')}
            backLink={{ to: '/dashboard', label: t('backToAdmin') }}
        >
            {children}
        </FullScreenLayout>
    );
};

const WidgetEditor: PageWithLayout = () => {
    const { t } = useTranslation();

    return (
        <>
            <Helmet>
                <title>{t('widgetEditor')}</title>
            </Helmet>

            <WidgetEditorForm integrationToken={INTEGRATION_TOKEN} />
        </>
    );
};

// Public on purpose: the URL is handed out directly and identifies the lift
// operator through its `liftOperatorId` query parameter, not through a session.
WidgetEditor.isProtected = false;
WidgetEditor.getLayout = (Component) => (
    <WidgetEditorLayout>{Component}</WidgetEditorLayout>
);

export default WidgetEditor;
